/**
 * SliderPressableContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled container for the slider element.
 */
const SliderPressableContainer = styled.div`
  cursor: pointer;
  position: absolute;
  height: ${520 * Screen.widthRatio}px;
  width: 100vw;
  left: 0;
  top: 0;
  z-index: 40; // Above rails but below the top bar
`;

export default withOpacity(SliderPressableContainer);
